import { schemaLoader } from '@civic/credential-commons';
import { CredentialService } from './credentialService';
import StaticCredentialService from './staticCredentialService';
import SchemaLoader from './schemaService';
import schemaMapping from '../../utils/jsonSchemaLoader';

schemaLoader.addLoader(new SchemaLoader(schemaMapping));

// TODO: This will be replaced by the presentation service
// once the static schema loader is available there
const credentialService: CredentialService = new StaticCredentialService();

export default credentialService;
